import Vue from 'vue'
import VueRouter from 'vue-router'
import { jwtDecode } from 'jwt-decode'  // 用于解析 JWT
import axios from 'axios'
import { MessageBox } from 'element-ui'

Vue.use(VueRouter)

const routes = [
  { path: '/buyfood', name: 'buyfood', component: () => import('../views/element/BuyfoodView.vue') },
  { path: '/search', name: 'search', component: () => import('../views/element/SearchView.vue') },
  { path: '/food', name: 'food', component: () => import('../views/element/FoodView.vue') },
  { path: '/address', name: 'address', component: () => import('../views/element/AddressView.vue') },
  { path: '/money', name: 'money', component: () => import('../views/element/MoneyView.vue') },
  { path: '/user', name: 'user', component: () => import('../views/element/UserView.vue') },
  { path: '/order', name: 'order', component: () => import('../views/element/OrderView.vue') },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/element/Login1View.vue'),
    meta: { public: true } // 不需要登录的页面
  },
  { path: '/shop', name: 'shop', component: () => import('../views/element/ShopView.vue') },
  { path: '/', redirect: '/login' }
]

const router = new VueRouter({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  },
  routes
})

// 校验 JWT 有效性
function isJwtValid() {
  const token = localStorage.getItem('token')
  if (!token) return false

  try {
    const decoded = jwtDecode(token)
    const now = Date.now() / 1000
    return decoded.exp && decoded.exp > now
  } catch (e) {
    return false
  }
}

// 全局前置守卫
router.beforeEach((to, from, next) => {
  const isAuthenticated = isJwtValid()

  if (to.meta.public) {
    // 登录页等公开页面
    if (to.path === '/login' && isAuthenticated) {
      return next('/buyfood') // 已登录则跳首页
    }
    return next() // 允许访问公开页
  }

  if (!isAuthenticated) {
    // token 无效或过期时，跳回登录页
    return next({ path: '/login', query: { redirect: to.fullPath } })
  }

  let isKicked = false; // 防重复弹出
  axios.interceptors.response.use(
    response => response,
    error => {
      if (error.response && error.response.status === 409&& !isKicked) {
        MessageBox.confirm('该账号被其它设备使用或验证信息丢失，请重新登录', '提示', {
          confirmButtonText: '确定',
          showCancelButton: false,  // 不显示取消按钮
          showClose: false,         // 不显示右上角关闭按钮
          type: 'warning',
          closeOnClickModal: false, // 禁止点击遮罩关闭
          closeOnPressEscape: false // 禁止按 Esc 关闭
        }).then(() => {
          localStorage.removeItem('token');
          window.location.href = '/login';
        })

      }
      return Promise.reject(error);
    }
  );
  next() // 正常放行
})

export default router

